module.exports = __webpack_public_path__ + "img/product-icon_13.bc10df91.png";